import axios, { AxiosResponse } from "axios";
import { UserShow } from "../models/User";

const API_BASE_URL = window._env_.REACT_APP_PAROLA_API_URL;
const API_RESOURCE = "login/";

export default class UserService {
  public static async login(username: string, password: string) {
    try {
      const response = await axios.post(
        API_BASE_URL + API_RESOURCE + "access-token",
        new URLSearchParams({
          username: username,
          password: password,
        }),
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      );

      const tokenData = response.data;
      sessionStorage.setItem("token", tokenData["access_token"]);
      return tokenData["access_token"];
    } catch (error: any) {
      if (error.response) {
        return Promise.reject({
          status: error.response.status,
          message: error.response.data?.message || "Login failed",
        });
      } else {
        return Promise.reject({ status: 500, message: "Server error" });
      }
    }
  }

  public static async validateAccessToken() {
    try {
      const response = await axios.post(
        API_BASE_URL + API_RESOURCE + "test-token",
        null,
        {
          headers: UserService.getAuthHeader(),
        }
      );

      const currentUser = response.data as UserShow;
      return UserShow.from(currentUser);
    } catch (error: any) {
      sessionStorage.removeItem("token");
      return Promise.reject(error);
    }
  }

  // static validateAccessToken(): Promise<UserShow> {
  //   const token = localStorage.getItem("token");

  //   return new Promise((resolve, reject) => {
  //     if (token === "fake-token-1234") {
  //       resolve({
  //         id: "1",
  //         idx: 1,
  //         name: "Test User",
  //         role: {
  //           idx: 1,
  //           name: "admin",
  //           permissions: [
  //             {
  //               idx: 1,
  //               resource: "parking",
  //               read: true,
  //               write: true,
  //             },
  //           ],
  //         },
  //       });
  //     } else {
  //       reject({ status: 401 });
  //     }
  //   });
  // }

  public static getAccessToken() {
    return sessionStorage.getItem("token");
  }

  public static getAuthHeader() {
    const token = UserService.getAccessToken();
    if (token) {
      return { Authorization: "Bearer " + token };
    } else {
      return { Authorization: "" };
    }
  }

  public static async getSideBar(): Promise<string[] | null> {
    try {
      const response: AxiosResponse<string[]> = await axios.get(
        API_BASE_URL + "users/sidebar",
        {
          headers: UserService.getAuthHeader(),
        }
      );
      return response.data;
    } catch (error) {
      console.error(error);
      return null;
    }
  }

  public static async getDefaultView(): Promise<string | null> {
    try {
      const response: AxiosResponse<string> = await axios.get(
        API_BASE_URL + "users/default_view",
        {
          headers: UserService.getAuthHeader(),
        }
      );
      return response.data;
    } catch (error) {
      console.error(error);
      return null;
    }
  }
}
